import {
  AlignmentType,
  Footer,
  Header,
  ImageRun,
  Paragraph,
  TextRun,
} from "docx";
import { energien_logo } from "../docImages/energien";

export const styles_energien = {
  companyId: ["12448"],
  companyName: "Energien",
  font: "Arial",
  titleSize: 21,
  textSize: 21,
  lineSpacing: 350,
  marginRight: 900,
  marginLeft: 900,
  marginBottom: 1000,
  beforeParagraph: 200,

  header: new Header({
    children: [
      new Paragraph({
        spacing: {
          before: 750,
          after: 0,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new ImageRun({
            data: energien_logo,
            transformation: {
              width: 800,
              height: 500,
            },
            floating: {
              behindDocument: true,
              allowOverlap: true,
              horizontalPosition: {
                offset: 0,
              },
              verticalPosition: {
                offset: 0,
              },
            },
          }),
        ],
      }),
    ],
  }),

  footer: new Footer({
    children: [
      new Paragraph({
        children: [
          new TextRun({
            text: "_____________________________________________________________________________",
            size: 18,
          }),
        ],
        alignment: AlignmentType.CENTER,
        spacing: { before: 100, after: 100 },
      }),
      new Paragraph({
        children: [
          new TextRun({
            text: "Teléfono: (+54) 911 5020 5141 | Mail: Leda.iruzun@energien.com.ar",
            size: 18,
          }),
        ],
        alignment: AlignmentType.CENTER,
      }),
    ],
  }),
};
